export default __webpack_public_path__ + "static/media/awc-dropdown.ab6cf71a.webp";